import { Box, Input, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { EXTERNAL_PARTNER } from '~/constants'
import STORAGE_KEYS from '~/constants/localStorage'
import { selectRestaurant } from '~/redux/restaurantSlice'
import ButtonConfirm from './ButtonConfirm'
import { hidePopupTopPage } from '~/redux/popupTopPageSlice'
import { KEY_PAGE_POPUP } from '~/constants/popupTopPage'

const MAX_PEOPLE = 999
// Lựa chọn số người trong trường hợp là smaregi
const NumberOfPeopleSelection = ({ setKeyPage }) => {
  const { externalPartner, number_of_people } = useSelector(selectRestaurant)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  //State
  const [numberOfPeople, setNumberOfPeople] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [isFocusInput, setIsFocusInput] = useState(false)

  const handleConfirmNumberOfPeople = () => {
    if (numberOfPeople) {
      localStorage.setItem(STORAGE_KEYS.NUMBER_OF_PEOPLE, Number(numberOfPeople))
      dispatch(hidePopupTopPage())
      setKeyPage(KEY_PAGE_POPUP.LANGUAGE) // Di chuyển về trang chọn popup language
    }
  }

  const onChangeInput = (e) => {
    const { value } = e.target
    if (MAX_PEOPLE <= value || MAX_PEOPLE.toString().length >= 4 || value === '0') return
    setInputValue(value)
    setNumberOfPeople(value)
  }

  const onChooseNumber = (numb) => {
    setNumberOfPeople(numb)
    setInputValue('')
  }

  const renderTitle = () => {
    return (
      <Box>
        <Typography fontSize="2.4rem" fontWeight="700" lineHeight="3.4rem">
          {t('titles.how_many_people')}
        </Typography>
        <Typography fontSize="1.4rem" mt="4px">
          {t('titles.please_select_number_of_people')}
        </Typography>
      </Box>
    )
  }

  const renderBoxNumber = () => {
    const arrayNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, '+']
    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        flex={1}
        flexWrap={'wrap'}>
        {arrayNumber.map((i, index) => {
          const isSelectedNumber = numberOfPeople === i || (i === '+' && inputValue)
          if (i === '+')
            return (
              <Box
                key={index}
                sx={{
                  width: 46,
                  height: 46,
                  marginTop: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  fontSize: '2rem',
                  fontWeight: '600',
                  border: '1px solid #000000',
                  borderRadius: '100%',
                  backgroundColor: isSelectedNumber ? '#000000' : '#ffffff',
                }}>
                <Input
                  disableUnderline
                  onFocus={() => {
                    setIsFocusInput(true)
                    setNumberOfPeople(null)
                  }}
                  onBlur={() => {
                    setIsFocusInput(false)
                  }}
                  inputProps={{
                    sx: {
                      textOverflow: 'ellipsis',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      borderRadius: '100%',
                      marginTop: 0.4,
                      fontSize: '2rem',
                      fontWeight: '500',
                      color: isSelectedNumber ? '#ffffff' : '#000000',
                      '&::placeholder': {
                        color: '#000000',
                        opacity: 1, // otherwise firefox shows a lighter color
                      },
                    },
                  }}
                  type="text"
                  placeholder={isFocusInput ? '' : '+'}
                  onChange={onChangeInput}
                  value={inputValue}
                />
              </Box>
            )
          return (
            <Box
              onClick={() => onChooseNumber(i)}
              key={index}
              sx={{
                width: 46,
                height: 46,
                marginTop: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                fontSize: '2rem',
                paddingTop: 0.4,
                fontWeight: '600',
                border: '1px solid #000000',
                borderRadius: '100%',
                color: isSelectedNumber ? '#ffffff' : '#000000',
                backgroundColor: isSelectedNumber ? '#000000' : '#ffffff',
              }}>
              {i}
            </Box>
          )
        })}
      </Box>
    )
  }

  const renderBtnConfirm = () => {
    return (
      <ButtonConfirm
        onClick={handleConfirmNumberOfPeople}
        label={t('actions.confirm')}
        disabled={numberOfPeople ? false : true}
        style={{
          backgroundColor: numberOfPeople ? '#000000' : 'rgba(0, 0, 0, 0.25)',
          color: '#fff',
        }}
      />
    )
  }

  if (
    externalPartner !== EXTERNAL_PARTNER.Smaregi ||
    (externalPartner === EXTERNAL_PARTNER.Smaregi && number_of_people)
  )
    return null
  return (
    <Box
      display="flex"
      flex={1}
      flexDirection="column"
      justifyContent="space-between"
      height="100%">
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        {renderTitle()}
        {renderBoxNumber()}
      </Box>
      {renderBtnConfirm()}
    </Box>
  )
}

NumberOfPeopleSelection.propTypes = {
  setKeyPage: PropTypes.func,
}

export default React.memo(NumberOfPeopleSelection)
